import LoggedInLayout from '../../components/LoggedInLayout';
import RequestsTable from '../../components/RequestsTable';

function Requests() {
   return (
      <LoggedInLayout>
         <div className="min-h-screen bg-gray-100">
            <RequestsTable
               baseFundUrl="me/managed-funds"
               managedFundsUrl="me/managed-funds"
               requestsBaseUrl="me/requests"
            />
         </div>
      </LoggedInLayout>
   );
}

export default Requests;
